import { createFileRoute } from '@tanstack/react-router';
import { requireWorkstation } from '../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../pages/Loading/Loading';

const ManufacturingOrder = lazy(() => import('../../../../pages/ManufaturingOrder/ManufacturingOrder'));

export const Route = createFileRoute('/$lang/_authenticated/mo')({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <ManufacturingOrder />
    </Suspense>
  ),
});
